import { makeStyles } from 'tss-react/mui';

export const useChatMessagesHeaderStyles = makeStyles()((theme) => ({
  chatHeaderTemplateWrapper: {
    padding: '8px 16px',

    [theme.breakpoints.down('sm')]: {
      padding: '8px 8px',
    },
  },
  minimizeButtonWrapper: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  textWrapper: {
    maxWidth: '90%',

    '@media (max-width: 360px)': {
      maxWidth: '70%',
    },
  },
}));
